import { render, staticRenderFns } from "./editQuestionTitle.vue?vue&type=template&id=2c6a88ec"
import script from "./editQuestionTitle.vue?vue&type=script&lang=js"
export * from "./editQuestionTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports